<app-content-header i18n-title title="Booking with Partner Payments" i18n-subTitle
                    subTitle="An overview of all bookings with partner payments"
                    [backgroundImage]="backgroundImage"
                    [containerClass]="containerClass"
                    [subContainerClass]="subContainerClass"
                    [pyClass]="pyClass"
                    [contentClass]="contentClass"
                    [h1class]="h1class"
                    [h2class]="h2class"
                    [subContainerBackgroundImage]="subContainerBackgroundImage"
                    [containerBackgroundImage]="containerBackgroundImage"
></app-content-header>

<app-content-breadcrumb [elements]="breadCrumbElements"></app-content-breadcrumb>
<div class="content">
  <div class="row">
    <div class="col-md-3">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Filter</h3>
        </div>

        <!-- -->
        <div class="block-content block-content-full">
          <form [formGroup]="form" (ngSubmit)="loadChangeRequestsToCheck()">

            <div class="row">
              <label class="col-12" for="bookingId">BookingId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="BookingId"
                       autocomplete="off"
                       id="bookingId"
                       formControlName="bookingId">
              </div>
            </div>

            <div class="row">
              <label class="col-12" for="requestId">RequestId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="RequestId"
                       autocomplete="off"
                       id="requestId"
                       formControlName="requestId">
              </div>
            </div>

            <div class="row">
              <label class="col-12" for="offerId">OfferId</label>
              <div class="col-12">
                <input type="text" class="form-control"
                       placeholder="OfferId"
                       autocomplete="off"
                       id="offerId"
                       formControlName="offerId">
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <button class="btn btn-info btn-sm" type="submit">Apply Filter</button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Bookings with Partner Payments</h3>
        </div>
        <div class="block-content block-content-full">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th>BookingId</th>
                <th>OfferId</th>
                <th>RequestId</th>
                <th>CreatedAt</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody *ngIf="bookings != null && pagination != null">
              <tr *ngFor="let booking of bookings | paginate: {
              itemsPerPage: pagination.limit,
              currentPage: pagination.page,
              totalItems: pagination.total}"
              >
                <td>{{ booking._id }}</td>
                <td>{{ booking.offer }}</td>
                <td>{{ booking.request }}</td>
                <td>{{ booking.created }}</td>
                <td>
                  <button class="btn btn-sm btn-primary" (click)="requestChangeRequestDetails(booking._id)">
                    Edit
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="block-content block-content-sm bg-body-light font-size-sm text-center">
          <pagination-controls [maxSize]="10"
                               (pageChange)="sendPage($event)"
                               *ngIf="pagination != null">
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
<tripmakery-booking-payment-partner-edit-modal></tripmakery-booking-payment-partner-edit-modal>
